const getters = {
  getSlotSwitcherIndex: state => state.slotSwitcherIndex,
}

export default getters
